import { getToken, isSessionValid, clearSession } from '../utils/sessionUtils';

const Api = () => {
    const ejecutaapi = async (endpoint, body) => {
        // 1. Verify valid session
        if (!isSessionValid()) {
            clearSession();
            window.location.href = '/login';
            return Promise.reject(new Error('Sesión expirada'));
        }

        // 2. Get token
        const token = getToken();

        // 3. Make request with Bearer token
        const header = {
            method: "POST",
            body: body,
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            }
        };

        const response = await fetch(process.env.REACT_APP_URL_API + endpoint, header);

        // 4. Handle 401 responses
        if (response.status === 401) {
            clearSession();
            window.location.href = '/login';
            return Promise.reject(new Error('Sesión expirada o token inválido'));
        }

        const dataResponse = await response.json();
        return dataResponse;
    };

    return [ejecutaapi];
};
export default Api;
